import { render, staticRenderFns } from "./MiniBasket.vue?vue&type=template&id=92c57ea6&scoped=true"
import script from "./MiniBasket.vue?vue&type=script&lang=js"
export * from "./MiniBasket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c57ea6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitrix/ext_www/igr.ru/local/templates/main/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92c57ea6')) {
      api.createRecord('92c57ea6', component.options)
    } else {
      api.reload('92c57ea6', component.options)
    }
    module.hot.accept("./MiniBasket.vue?vue&type=template&id=92c57ea6&scoped=true", function () {
      api.rerender('92c57ea6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MiniBasket.vue"
export default component.exports